import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { LoadDocBtn, ModuleTitleText } from '@ru-digital-assets/ui-component';
import { createHash } from 'crypto-pro';
import { get } from 'lodash';
import FormFooter from '../../../containers/form-footer';
import { useSign } from 'hooks';
import IconBtn from '../../../modules/icon-btn/icon-btn';
import Step from '../../../modules/step';
import UiList from '../../../modules/ui/ui-list/ui-list';
import UiSelect from '../../../modules/ui/ui-select/ui-select';
import { useAppDispatch } from '../../../store';
import {
  getAgreementDoc,
  getPurchase,
  holdPurchase,
  paymentPurchaseConfirm,
  paymentPurchaseUpload,
  signPurchase,
} from '../../../store/actions/operations-sign';
import { RootState } from '../../../types';
import currencyFormat from '../../../utils/currencyFormat';
import {
  getPdfFromBase64,
} from '../../../utils/files/downloadFile';
import { getPurchaseStatusBadge } from 'utils/getStatusBadge';
import { getFormatDate } from '../../../utils/utils';
import UcpDocs from '../../ucp-sign/ucp-docs/ucp-docs';
import { PrivateKeyButton } from 'components';
import SignIcon from 'assets/icons/sign-icon';
import './index.scss';
import TransactionDetailsTable from '../../TransactionDetailsTable';
import AppCheckbox from '../../../modules/app-checkbox/app-checkbox';

import fileDownload from 'js-file-download';

interface IAssetsBuyingInfoForm {
  onSignHold?: () => void;
  onSignPay?: () => void;
}

const AssetsBuyingInfoForm = ({
  onSignHold,
  onSignPay,
}: IAssetsBuyingInfoForm) => {
  const history = useHistory();
  const id = history.location.state?.id;
  const [file, setFile] = useState<File>();
  const [approvePayment, setApprovePayment] = useState(false);
  const [approveRisk, setApproveRisk] = useState(false);
  const dispatch = useAppDispatch();
  const purchase: any = useSelector(
    (state: RootState) => state.operationsSign.data.purchase
  );
  const [privateKey, setPrivateKey] = useState('');

  const paymentTokens = useSelector(
    (state: RootState) => state.commonInfo.paymentTokens
  );

  console.log('purchase.status', purchase?.status);

  const isSignActive = useMemo(() => {
    if (!purchase) return false;
    if (purchase.isInitiator) {
      return purchase.status === 'INITIALIZED';
    } else {
      return purchase.status === 'SIGNED';
    }
  }, [purchase]);

  const {
    certificatesList,
    selectedCertificate,
    signEntity,
    onUserSelectCertificate,
  } = useSign(isSignActive);

  useEffect(() => {
    if (id) {
      dispatch(getPurchase({ id }));
    }
  }, [id]);

  const onSpecDownload = (
    title: string,
    type: 'AGREEMENT' | 'COUNTER_APPLICATION' | 'PAYMENT_CONFIRMATION',
    signed: boolean
  ) => {
    id &&
      dispatch(getAgreementDoc({ decisionId: id, type, signed })).then(
        (res: any) => {
          getPdfFromBase64(res.payload.doc);
          // downloadFile(
          //   resultBlob,
          //   `${title}.pdf${signed ? '.sig' : ''}`,
          //   'application/pdf'
          // );
          fileDownload(
            res.payload.doc,
            `${title}.pdf${signed ? '.sig' : ''}`,
            'application/pdf'
          );
        }
      );
  };

  const handleSign = () => {
    id &&
      dispatch(
        getAgreementDoc({
          decisionId: id,
          type: 'COUNTER_APPLICATION',
          signed: false,
        })
      ).then(async (res: any) => {
        const { pdfSigned } = await signEntity(res.payload.hash || '');
        if (pdfSigned)
          dispatch(
            signPurchase({
              info: {
                hash: res.payload.hash,
                signature: pdfSigned,
                operationId: id,
              },
            })
          ).then(() => dispatch(getPurchase({ id })));
      });
  };

  const handleInitSign = () => {
    id &&
      dispatch(
        getAgreementDoc({
          decisionId: id,
          type: 'AGREEMENT',
          signed: false,
        })
      ).then(async (res: any) => {
        const { pdfSigned } = await signEntity(res.payload.hash || '');
        if (pdfSigned)
          dispatch(
            signPurchase({
              info: {
                hash: res.payload.hash,
                signature: pdfSigned,
                operationId: id,
              },
            })
          ).then(() => dispatch(getPurchase({ id })));
      });
  };

  const handleApprove = () => {
    file &&
      dispatch(
        paymentPurchaseUpload({
          info: {
            id,
            file,
          },
          callback: () => {
            history.push('/assets/result', {
              title: `Подтверждение оплаты успешно отправлено!`,
              titlePage: 'Продажа цифровых финансовых активов',
              description:
                'Ожидайте пока Продавец подтвердит получение денежных средств',
              items: [
                { link: '/assets', title: 'Активы' },
                { link: '#', title: 'Покупка' },
              ],
              iconType: 'assets',
            });
          },
        })
      );
  };

  const handleCryptoSignHold = async () => {
    if (purchase?.status === 'AGENT_DOC_SIGNED') {
      dispatch(
        holdPurchase({
          info: {
            operationId: id,
            privateKey: privateKey,
          },
          callback: () => {
            dispatch(getPurchase({ id }));
            onSignHold && onSignHold();
          },
        })
      );
    }

    if (purchase?.status === 'PAYMENT_DOC_UPLOADED') {
      const payload = {
        from: purchase?.agentCompanyInfo.id,
        to: purchase?.initiatorCompanyInfo.id,
        value: purchase?.tokenCount,
        key: privateKey,
      };
      const bufferHash = await createHash(JSON.stringify(payload));
      dispatch(
        paymentPurchaseConfirm({
          info: {
            id,
            signature: bufferHash,
            payload,
          },
          callback: () => onSignPay && onSignPay(),
        })
      );
    }
  };

  const decisionDocs = useMemo(() => {
    const docs = [];
    const isSigByBuyer = [
      'SIGNED', 'AGENT_DOC_SIGNED', 'AGENT_SIGNED', 'PAYMENT_DOC_UPLOADED'
    ].includes(purchase?.status);
    docs.push(
      <LoadDocBtn
        key="purchase-request"
        title="Заявка на покупку ЦФА"
        extension=".PDF"
        onSpecDownload={() =>
          onSpecDownload('Заявка на покупку ЦФА', 'AGREEMENT', false)
        }
        secondExtension={isSigByBuyer ? '.SIG' : undefined}
        onSecondSpecDownload={isSigByBuyer ? () =>
          onSpecDownload('Заявка на покупку ЦФА', 'AGREEMENT', true)
          : undefined}
      />
    );

    const isSigBySeller = [
      'PAYMENT_DOC_UPLOADED',
      'AGENT_DOC_SIGNED',
      'AGENT_SIGNED',
      'PAYMENT_DOC_UPLOADED',
      'APPLIED',
    ].includes(purchase?.status);

    (purchase?.status === 'APPLIED' ||
      purchase?.status === 'DOC_SIGNED' ||
      purchase?.status === 'AGENT_SIGNED' ||
      purchase?.status === 'AGENT_DOC_SIGNED' ||
      purchase?.status === 'PAYMENT_DOC_UPLOADED' ||
      (purchase?.status === 'SIGNED' && !purchase?.isInitiator)) &&
      docs.push(
        <LoadDocBtn
          key="counter-application"
          title="Встречная заявка"
          onSpecDownload={() =>
            onSpecDownload('Встречная заявка', 'COUNTER_APPLICATION', false)
          }
          secondExtension={isSigBySeller ? '.SIG' : undefined}
          onSecondSpecDownload={
            isSigBySeller
              ? () =>
                onSpecDownload(
                  'Встречная заявка',
                  'COUNTER_APPLICATION',
                  purchase?.status === 'AGENT_DOC_SIGNED' ||
                  purchase?.status === 'APPLIED' ||
                  purchase?.status === 'PAYMENT_DOC_UPLOADED'
                )
              : undefined
          }
        />
      );

    ['PAYMENT_DOC_UPLOADED', 'APPLIED'].includes(purchase?.status) &&
      docs.push(
        <LoadDocBtn
          key="payment-confirmation"
          title="Подтверждение оплаты"
          onSpecDownload={() =>
            onSpecDownload(
              'Подтверждение оплаты',
              'PAYMENT_CONFIRMATION',
              false
            )
          }
        />
      );

    return docs;
  }, [purchase]);

  return (
    <div className="ucp__left">
      <div className="ucp__top">
        {purchase.status && purchase.status !== 'APPLIED' && (
          <Step
            steps={[
              { title: 'Параметры' },
              {
                title: 'Подпись',
                active: ['INITIALIZED'].includes(
                  purchase?.status
                ),
              },
              {
                title: 'Согласование',
                active: ['SIGNED', 'AGENT_DOC_SIGNED'].includes(
                  purchase?.status
                ),
              },
              {
                title: 'Подтвеждение оплаты',
                active: ['AGENT_SIGNED', 'PAYMENT_DOC_UPLOADED'].includes(
                  purchase?.status
                ),
              },
            ]}
          />
        )}

        <h3 className="h3">Заявка:</h3>
        <p>
          {`${purchase?.isInitiator ? 'Покупка' : 'Продажа'} ${purchase?.tokenCount || 0
            } токенов ${paymentTokens.find((p) => p.code === purchase?.tokenName)?.name
            } на сумму ${currencyFormat(
              Number(get(purchase, 'amount', 0))
            )} от ${getFormatDate(
              get(purchase, 'createdAt', new Date()),
              'dd MMM yyyy',
              true
            )}`}
        </p>
        <div className="status">
          {getPurchaseStatusBadge(purchase.status, purchase.isInitiator)}
        </div>
      </div>
      <div className="ucp__content">
        <div className="ucp__ontractors">
          <h3 className="h3">Детали операции:</h3>
          <div className="ucp__ontractors-body">
            <div className="ucp__ontractors__left">
              <UiList
                list={[
                  {
                    label: 'Покупатель:',
                    value: get(purchase, 'initiatorCompanyInfo.shortName', ''),
                  },
                  {
                    label: 'ИНН:',
                    value: get(purchase, 'initiatorCompanyInfo.tin', ''),
                  },
                ]}
                sm
              />
            </div>
            <div className="ucp__ontractors__right">
              <UiList
                list={[
                  {
                    label: 'Продавец:',
                    value: get(purchase, 'agentCompanyInfo.shortName', ''),
                  },
                  {
                    label: 'ИНН:',
                    value: get(purchase, 'agentCompanyInfo.tin', ''),
                  },
                ]}
                sm
              />
            </div>
            <div className="ucp__ontractors__right">
              <UiList
                list={[
                  {
                    label: 'Дата создания:',
                    value: getFormatDate(
                      get(purchase, 'createdAt'),
                      undefined,
                      true
                    ),
                  },
                ]}
                sm
              />
            </div>
          </div>
        </div>

        <UcpDocs docs={decisionDocs} />
        <TransactionDetailsTable
          fromHash={purchase?.senderBlockchainAddress}
          toHash={purchase?.recipientBlockchainAddress}
          toName={get(purchase, 'initiatorCompanyInfo.shortName', '')}
          fromName={get(purchase, 'agentCompanyInfo.shortName', '')}
          transactionType="purchase"
        />
        <FormFooter skipCheck={!isSignActive}>
          <div className="flex justify-end form-asset-credit__container">
            {purchase?.status === 'INITIALIZED' && purchase?.isInitiator && (
              <div className="flex issuer-footer align-center">
                <div className="flex justify-end issuer-footer align-center">
                  <div className="flex justify-end">
                    <UiSelect
                      label="Выберите подпись:"
                      value={selectedCertificate}
                      options={certificatesList}
                      lg
                      onChange={onUserSelectCertificate}
                    />
                    <IconBtn
                      lg
                      onClick={handleInitSign}
                      icon={<SignIcon />}
                      disabled={!selectedCertificate}
                      title="Подписать заявление "
                    />
                  </div>
                </div>
              </div>
            )}
            {purchase?.status === 'SIGNED' && purchase?.isInitiator && (
              <div className="flex issuer-footer align-center">
                <div className="flex justify-end issuer-footer align-center">
                  <div className="flex justify-end">
                    <p className="p ml_10 p_color_white">Ожидание подтверждения сделки продавцом</p>
                  </div>
                </div>
              </div>
            )}
            {purchase?.status === 'SIGNED' && !purchase?.isInitiator && (
              <div className="flex issuer-footer align-center">
                <div className="footer__go-back">
                  <AppCheckbox
                    onChangeValue={(val) => {
                      setApproveRisk(val);
                    }}
                    titleComponent={
                      <div className="module-title-text__desc">
                        Подтверждаю, что ознакомлен с{' '}
                        <a
                          className="a__link"
                          href="https://account.cfa.digital/risk_declaration.pdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          декларацией о рисках
                        </a>
                      </div>
                    }
                  />
                </div>
                <div className="flex justify-end issuer-footer align-center">
                  <div className="flex justify-end">
                    <UiSelect
                      label="Выберите подпись:"
                      value={selectedCertificate}
                      options={certificatesList}
                      lg
                      onChange={onUserSelectCertificate}
                    />
                    <IconBtn
                      lg
                      onClick={handleSign}
                      icon={<SignIcon />}
                      disabled={!selectedCertificate || !approveRisk}
                      title="Подать встречную заявку"
                    />
                  </div>
                </div>
              </div>
            )}
            {purchase?.status === 'AGENT_SIGNED' && purchase?.isInitiator && (
              <div className="flex justify-end align-center issuer-footer">
                <div className="flex justify-end">
                  <div className="upload">
                    <LoadDocBtn
                      title={
                        file ? file.name : 'Документ подтверждающий оплату'
                      }
                      extension="Выберите файл"
                      sm={false}
                    />
                    <input
                      id="file"
                      type="file"
                      onChange={(e: any) => setFile(e.target.files[0])}
                    />
                  </div>
                  <IconBtn
                    onClick={handleApprove}
                    lg
                    disabled={!file}
                    icon={<SignIcon />}
                    title="Подтвердить оплату"
                  />
                </div>
              </div>
            )}
            {purchase?.status === 'AGENT_DOC_SIGNED' && !purchase?.isInitiator && (
              <div className="flex justify-end issuer-footer align-center">
                <div className="flex justify-end align-stretch">
                  <div className="mr_10">
                    <PrivateKeyButton
                      onKeyChange={(key) => setPrivateKey(key || '')}
                    />
                  </div>
                  <IconBtn
                    onClick={handleCryptoSignHold}
                    lg
                    disabled={!privateKey}
                    icon={<SignIcon />}
                    title="Подписать транзакцию"
                  />
                </div>
              </div>
            )}
            {purchase?.status === 'PAYMENT_DOC_UPLOADED' &&
              !purchase?.isInitiator && (
                <div className="flex issuer-footer align-center">
                  <div className="footer__go-back">
                    <AppCheckbox
                      onChangeValue={(val) => {
                        setApprovePayment(val);
                      }}
                      titleComponent={
                        <div className="module-title-text__desc">
                          Подтверждаю, что оплата произведена
                        </div>
                        // <ModuleTitleText top="Подтверждаю, что оплата произведена" />
                      }
                    />
                  </div>
                  <div className="flex justify-end align-stretch">
                    <div className="mr_10">
                      <PrivateKeyButton
                        onKeyChange={(key) => setPrivateKey(key || '')}
                      />
                    </div>
                    <IconBtn
                      onClick={handleCryptoSignHold}
                      lg
                      disabled={!privateKey || !approvePayment}
                      icon={<SignIcon />}
                      title="Подписать транзакцию"
                    />
                  </div>
                </div>
              )}
            {purchase?.status === 'AGENT_SIGNED' && !purchase?.isInitiator && (
              <>
                <div className="flex justify-end">
                  <div className="form-assets__flex">
                    <div className="form-assets__item form-assets__item--sm">
                      <ModuleTitleText top="Дождитесь, пока покупатель сделает перевод денежных средств на указанные в заявке реквизиты" />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </FormFooter>
      </div>
    </div>
  );
};

export default AssetsBuyingInfoForm;
